goog.provide("shadow.js.shim.module$$mui$material$ListItemIcon");
goog.provide("module$shadow_js_shim_module$$mui$material$ListItemIcon");
shadow.js.shim.module$$mui$material$ListItemIcon = shadow.js.nativeProvides["@mui/material/ListItemIcon"] = shadow$bridge("@mui/material/ListItemIcon");
module$shadow_js_shim_module$$mui$material$ListItemIcon.default = shadow.js.shim.module$$mui$material$ListItemIcon;
